export enum AuthenticationStep {
  Loading,
  Setup,
  Enroll,
  StepUp,
  Notification,
  Error
}

export enum AuthStep {
  PRE_SETUP,
  SETUP,
  STEP_UP,
  NOTIFICATION,
  RESULT
}
